<template>
  <article>
    <div class="wrap_title">
      <h1>{{ $t("MLGI-03-01-03-03") }}</h1>
    </div>
    <template v-if="lang == $config.LANG_KOR">
      <div class="cont_info type1">
        <p>
          KB 국민은행 오클랜드지점(“당행")은 고객의 개인정보와 재무정보 보호를 중요하게 여기고 있습니다. 당행은 금융 서비스를 제공하는 기관으로서 당행의 상품과 서비스를 제공할 때에
          고객의 개인정보를 취득해야 합니다. 이 정보가 고객의 기밀하고 중요한 정보이기 때문에 고객은 당행이 어떻게 고객의 정보를 처리하는지 알고 있어야 합니다.
        </p>
        <br />
        <p>
          당행에게 개인정보를 제공할 때에는 본 개인정보 보호정책에 따라 제공하는 것이며, 본 개인정보 보호정책에 열거된 내용에 대하여 동의하는 것으로 판단합니다. 또한, 당행은
          개인정보 보호정책을 필요에 따라 변경할 권리를 가지고 있으며, 변경된 개인정보 보호정책은 항상 당행 사이트에 공시할 것입니다.
        </p>
      </div>
      <div class="wrap_cont">
        <div class="wrap_title">
          <h2 class="h_title2">개인정보의 처리 목적</h2>
        </div>
        <p>당행은 개인정보의 중요성을 인지하고 있으며 인터넷환경에서 개인정보를 보호하기 위하여 노력합니다. 당행은 개인정보를 다음 각 호의 목적을 위해 처리합니다.</p>
        <dl class="explain">
          <dt>금융거래 주) 관계 관련</dt>
          <dd>
            금융거래와 관련하여 신용조회회사 또는 신용정보집중기관에 대한 개인신용정보의 조회, 금융거래 관계의 설정 여부의 판단, 금융거래 관계의 설정·유지·이행·관리, 금융사고 조사,
            분쟁 해결, 민원 처리 및 법령상 의무이행 등의 목적으로 개인정보를 처리합니다.
          </dd>
          <dd>주)금융거래라 함은 은행업무(여신, 수신, 외국환 등)와 관련된 거래를 의미합니다.</dd>
        </dl>
        <dl class="explain">
          <dt>온라인 거래 관련 목적</dt>
          <dd>접속빈도 파악, 회원의 서비스 이용에 대한 통계, 전자금융거래의 내용 추적 및 검색, 보안정책 수립용 통계 자료로 활용 등을 목적으로 개인정보를 처리합니다.</dd>
        </dl>
        <dl class="explain">
          <dt>기타 목적</dt>
          <dd>
            - 회원 가입 및 관리
            <br />
            - 상품 및 서비스 홍보 및 판매 권유
            <br />
            - 신규 서비스 개발
            <br />
            - 맞춤 서비스 제공
            <br />
            - 경품지급, 사은행사 등 고객의 편의 및 참여기회 제공
            <br />
            - 직원채용
            <br />
            - 당행이 제공하고 있거나 제공할 상품 또는 서비스에 대한 안내
            <br />
            - 채무감면 등 당행이 보유하고 있는 약관 또는 보안정책 강화
            <br />
            - 법적 소송절차, 범죄 방지, 탐문 또는 기소 등 법적인 요구사항에 의한 활동제공
            <br />
            - 법률집행기관 및 정부기관의 정보요구 시
            <br />
            - 기타 정보이용에 동의한 경우
          </dd>
        </dl>
        <br />
        <p>당행의 위에 언급한 개인정보처리목적을 변경할 필요가 있는 경우, 고객으로부터 사전동의를 구할 것입니다.</p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">개인정보의 처리 및 보유 기간</h2>
        </div>
        <p>금융거래와 관련한 개인(신용)정보는 수집·이용에 관한 동의일로부터 금융거래 종료일로부터 10년까지 위 이용목적을 위하여 보유·이용됩니다.</p>
        <p>단, 금융거래 종료일 이후에는 금융사고 조사, 분쟁 해결, 민원처리, 법령상 의무이행 및 당행의 리스크 관리업무만을 위하여 보유·이용됩니다.</p>
        <br />
        <p>
          개인(신용)정보의 조회를 목적으로 수집된 개인(신용)정보는 수집·이용에 대한 동의일로부터 고객에 대한 개인(신용)정보 제공·조회 동의의 효력 기간 후 10년까지 보유·이용됩니다.
          단, 개인(신용)정보 제공·조회 동의의 효력 기간 종료 후에는 금융사고 조사, 분쟁 해결, 민원처리 및 법령상 의무이행만을 위하여 보유·이용됩니다.
        </p>
        <br />
        <p>
          상품 및 서비스 홍보 및 판매 권유 등과 관련한 개인(신용)정보는 수집·이용에 관한 동의일로부터 동의 철회 일로부터 10년까지 보유·이용됩니다.단, 동의 철회일 후에는 위에 명시한
          [개인정보의 처리목적] 관련된 사고 조사, 분쟁 해결, 민원처리, 법령상 의무이행만을 위하여 보유·이용됩니다. 또한 개인(신용)정보를 보유하고 있는 기간 동안에는 당행으로부터
          상품 및 서비스 홍보 관련으로 연락을 받으실 수 있습니다. 만일 상품 및 서비스 홍보 관련 연락을 원치 않으실 경우, 오클랜드지점으로 이메일 또는 전화(+64-9-366-1000)를 주시기
          바랍니다. 당행이 보유하는 개인(신용)정보는 at Level 19, 135 Albert Street, PO BOX 7506, Wellesley Street, Auckland, New Zealand에 보관되어 있습니다.
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">개인정보 수집 출처 등 고지</h2>
        </div>
        <p>
          뉴질랜드 법률 The Privacy Act 1993에 의거, 고객은 당행이 수집한 개인정보를 접근 또는 수정할 권리를 가지고 있습니다. 고객은 당행에 서면으로 요청 시 언제든지 개인정보 정정
          또는 변경을 요구할 수 있습니다. 또한 당행은 정보주체의 요구를 거부하는 경우에는, 정당한 사유가 없는 한 정보주체의 요구가 있은 날로부터 3영업일 이내에 그 거부의 근거와
          사유를 정보주체에게 알립니다.
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">개인정보의 제3자 제공</h2>
        </div>
        <p>
          당행은 원칙적으로 고객의 개인정보를 본 개인정보 정책에서 명시한 목적 범위 내에서 처리하며, 고객의 사전 동의 없이는 본래의 범위를 초과하여 처리하거나 제3자에게 제공하지
          않습니다. 단, 다음의 각 호의 경우에는 고객 또는 제3자의 이익을 부당하게 침해할 우려가 있을 때를 제외하고는 개인정보를 목적 외의 용도로 이용하거나 이를 제3자에게 제공할 수
          있습니다.<br />
          <br />
        </p>
        <ul class="list txt">
          <li>고객이 사전에 제3자 제공 및 공개에 동의한 경우</li>
          <li>다른 법률에 특별한 규정이 있는 경우</li>
          <li>
            고객 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 고객 또는 제3자의 급박한 생명, 신체, 재산의
            이익을 위하여 필요하다고 인정되는 경우
          </li>
          <li>통계작성 및 학술연구 등의 목적을 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 개인정보를 제공하는 경우</li>
        </ul>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">개인정보처리 위탁</h2>
        </div>
        <p>개인정보 처리 위탁계약 시, 당행은 위탁업체가 개인정보 보호 및 개인정보의 제3자제공 관련 법령을 준수하고 본 개인정보 보호정책을 준수함을 보장합니다.</p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">고객의 권리 · 의무 및 그 행사방법</h2>
        </div>
        <p>
          고객은 당행이 처리하는 자신 및 16세 미만 아동(법정대리인만 해당)의 개인정보의 열람을 요구할 수 있습니다. 또한, 전자매체를 통하여 관련 정보의 복사본을 송부 받을 것에
          동의합니다.
        </p>
        <p>
          자신의 개인정보를 열람한 고객은 사실과 다르거나 확인할 수 없는 개인정보에 대하여 당행에 정정 또는 삭제를 요구할 수 있습니다. 다만, 다른 법령에서 그 개인정보가 수집
          대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
        </p>
        <p>
          고객은 당행에 대하여 자신의 개인정보 처리의 정지를 요구할 수 있습니다. 다만 다음 각 호의 어느 하나에 해당하는 경우에는 당행은 해당 사유를 고객에게 알리고, 처리정지 요구를
          거절할 수 있습니다.
          <br />
          <br />
        </p>
        <ul class="list txt">
          <li>법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우</li>
          <li>다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</li>
          <li>개인정보를 처리하지 아니하면 고객과 약정한 서비스를 제공하지 못하는 등 계약의 이행이 곤란한 경우로서 고객이 그 계약의 해지 의사를 명확하게 밝히지 아니한 경우</li>
        </ul>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">처리하는 개인정보의 항목</h2>
        </div>
        <p>당행은 금융거래의 설정·유지·이행·관리 및 상품서비스의 제공을 위한 필수정보 및 선택정보를 다음 각 호와 같이 수집하고 있습니다.</p>
        <dl class="explain">
          <dt>필수적 정보</dt>
          <dd>
            - 개인식별정보: 성명, 실명확인번호 등 고유식별정보, 국적, 주소·전자우편 주소·전화번호 등 연락처
            <br />
            - 금융거래정보: 상품종류, 거래조건(이자율, 만기, 담보 등), 거래 일시, 금액 등 거래 설정 및 내역 정보
            <br />
            - 기타 금융거래의 설정·유지·이행·관리를 위한 상담 등을 통해 생성되는 정보
          </dd>
        </dl>
        <dl class="explain">
          <dt>선택적 정보</dt>
          <dd>
            - 개인식별정보 외에 거래신청서에 기재된 정보 또는 고객이 제공한 정보
            <br />
            - 주거 및 가족사항, 거주기간, 세대구성, 결혼여부 등
          </dd>
        </dl>
        <dl class="explain">
          <dt>인터넷뱅킹 관련 수집 정보</dt>
          <dd>
            - 인터넷뱅킹거래의 내용 추적 및 검색: 고객 아이디, 접속 일시, IP Address, HDD Serial, MAC Address 등
            <br />
            - 보안정책 수립용 통계 자료: 개인방화벽 설정, 운영체제 종류, 운영체제 주요 보안패치 여부, 방화벽 설정, 원격접속 설정, 브라우저 버전, 키보드 타입 등
          </dd>
        </dl>
        <dl class="explain">
          <dt>수집방법</dt>
          <dd>
            - 당행 영업점에 내방한 고객으로부터 직접 수집
            <br />
            - 홈페이지, 서면양식, 팩스, 전화, 상담 게시판, 이메일, 응모내역, 배송요청
            <br />
            - 생성정보 수집 툴을 통한 수집
            <br />
            - 신용정보회사 등 제3의 업체를 통한 수집
          </dd>
        </dl>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">개인정보 자동 수집 장치의 설치, 운영 및 거부 관련사항</h2>
        </div>
        <p>당행은 고객께서 홈페이지에 접속하신 상태에서 이용자 인증을 위하여 '쿠키(Cookie)'를 이용하고 있습니다.</p>
        <p>
          쿠키는 이용자 사이트에 대한 기본 설정정보를 보관하기 위해 해당 웹사이트가 이용자의 컴퓨터 브라우저에 전송하는 소량의 정보입니다. 이용자가 웹사이트에 연결되어 있을 때,
          추가로 ID 등을 입력 할 필요 없이 서비스 제공자의 컴퓨터가 이용자의 부가정보를 찾아내어 연결에 관계하여 이용자의 브라우저상의 쿠키내용을 읽어내고 서비스를 제공하는
          것입니다.
        </p>
        <p>
          쿠키 이용에 대한 선택권은 고객이 가지고 있습니다. 고객님의 웹 브라우저에서 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부하는 등의
          옵션을 선택하실 수 있습니다. 단, 고객이 쿠키의 저장을 거부하는 옵션을 선택하시는 경우에는 서비스 이용에 불편이 야기될 수 있습니다.
        </p>
        <p>
          또한, 당행의 웹사이트는 다른 사이트로 연결하는 하이퍼링크를 포함하고 있습니다. 당행은 연결된 사이트의 개인정보정책 및 사이트에서 제공하는 정보의 안정성에 대하여 책임을
          지지 않습니다.
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">개인정보의 파기</h2>
        </div>
        <p>
          당행은 개인정보의 보유기간이 경과된 경우, 개인정보의 처리목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에 다음 각 호의 사유가 없는 한
          개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5영업일 이내에 그 개인정보를 파기합니다.
          <br />
          <br />
        </p>
        <ul class="list txt">
          <li>신용정보집중기관 또는 신용조회회사가 신용정보의 집중관리·활용 또는 개인의 신용도 등을 평가하기 위한 목적으로 개인신용정보를 보유하는 경우(보유기간에 한함)</li>
          <li>신용정보회사 등이 민·형사상의 책임 또는 시효가 지속되거나 분쟁의 입증자료로서 개인신용정보를 보유하는 경우</li>
          <li>법령에 따라 보존하여야 하는 경우</li>
          <li>기타 이와 유사한 정당한 사유가 있는 경우</li>
        </ul>
        <p>
          <br />
          개인정보가 기록된 출력물, 서면 등은 파쇄 또는 소각의 방법으로 파기하고, 전자적 파일형태의 개인정보는 복원이 불가능한 방법으로 영구 삭제하는 방법으로 파기합니다.
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">개인정보의 안전성 확보 조치</h2>
        </div>
        <p>당행은 다음 각 호와 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.</p>
        <dl class="explain">
          <dt>개인정보의 암호화</dt>
          <dd>
            고객의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의
            별도 보안기능을 사용하고 있습니다.
          </dd>
        </dl>
        <dl class="explain">
          <dt>해킹 등에 대비한 기술적 대책</dt>
          <dd>
            당행은 키보드 입력 값에 대한 해킹방지를 위한 가상키보드를 운영하고, 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치를
            권유하여 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하는 등 기술적·물리적으로 감시 및 차단하고 있습니다.
          </dd>
        </dl>
        <dl class="explain">
          <dt>개인정보처리시스템 접근 제한</dt>
          <dd>개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있습니다.</dd>
        </dl>
        <dl class="explain">
          <dt>개인정보 취급 직원의 최소화</dt>
          <dd>개인정보를 취급하는 직원을 지정하고 관련 담당자에 최소한의 개인정보를 제공하고 있습니다.</dd>
        </dl>
        <br />
        <dd>
          보안을 강화하기 위해서 고객의 인터넷 브라우저가 당행 웹사이트의 암호화 조건을 지원할 수 있는지 적합한 단계의 확인이 필요합니다. 당행이 추천하는 인터넷 브라우저의 더 많은
          정보는
          <router-link :to="{ name: 'kbBankingService' }" style="text-decoration: underline">이곳</router-link>을 클릭하면 살펴 보실 수 있습니다. 당행의 웹사이트는 고객이나 당행의
          특별한 요청 외에 고객의 개인정보를 수집하지 않습니다.
        </dd>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">개인정보 처리방침의 변경</h2>
        </div>
        <p>
          당행이 개인정보 처리방침을 변경하는 경우에는 변경 및 시행의 시기, 변경된 내용을 당행 사이트에 지속적으로 공개하며, 변경된 내용은 고객이 쉽게 확인할 수 있도록 변경 전·후를
          비교하여 공개합니다.
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">개인정보의 보호를 위해 알아야 할 기타사항</h2>
        </div>
        <p>
          귀하가 온라인 게시판이나 이메일, 메신저에서 제공한 정보는 타인에 의해 수집되거나 사용될 수 있음을 언제나 명심하시기 바랍니다. 예를 들어 원하지 않는 메시지를 받게 될 수도
          있습니다.
        </p>
        <p>귀하는 이용자 ID, 이용자 암호 또는 보안매체(일회용비밀번호생성기, OTP)를 철저하게 관리할 책임이 있으며, 인터넷뱅킹에 접속할 시 적절한 주의가 필요합니다.</p>
        <p>당행은 귀하가 개인정보를 부주의하게 이용하여 다른 곳에서 생긴 사고에 대해서는 책임을 지지 않습니다.</p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">권익침해 구제방법</h2>
        </div>
        <p>고객은 개인정보침해로 인한 신고나 상담이 필요하신 경우 아래 기관에 문의하시기 바랍니다.</p>
        <p>
          <strong class="fc_point1">KB국민은행 오클랜드 지점(+64 9 366 1000)</strong>
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">개인정보 보호책임자 및 개인정보 관리책임자</h2>
        </div>
        <dl class="addr">
          <dt>
            당행의 개인정보 보호 및 관리 책임자는 다음과 같습니다.
            <br />
            <br />
          </dt>
          <strong class="fc_point1">KB국민은행 오클랜드 지점장 김도한</strong>
          <dd>
            <strong class="fc_point1">[Physical Address]</strong>
            <span>Level 16, 88 Shortland Street, Auckland CBD, New Zealand, 1010</span>
          </dd>
          <dd>
            <strong class="fc_point1">[Postal Address]</strong>
            <span>PO Box 7506, Victoria Street West, Auckland CBD, New Zealand, 1142</span>
          </dd>
          <dd>전화 : +64 9 366 1000</dd>
        </dl>
      </div>
      <div class="wrap_cont type2">
        <div>
          <p>개인정보보호정책 버전번호: Ver.2.0</p>
          <p>개인정보보호정책 시행일자: 2020.6.30</p>
        </div>
      </div>
      <br /><br /><br />
    </template>
    <template v-else>
      <div class="cont_info type1">
        <p>
          KB KOOKMIN Bank Auckland Branch ("KB") recognizes the importance of safeguarding your personal and financial information. As an institution offering financial services,
          KB needs to obtain personal information about you in the course of providing our products and services. Because this information is confidential and important to you, we
          think it's important you know how we treat your information.
        </p>
        <br />
        <p>
          If you provide personal information to KB it is provided on the basis of this Privacy Policy and you accept the terms set out in this Privacy Policy. You acknowledge that
          KB is entitled to amend the terms of this Privacy Policy at any time and the amended terms shall apply from the date the amended Privacy Policy is displayed on KB’s
          website.
        </p>
      </div>
      <div class="wrap_cont">
        <div class="wrap_title">
          <h2 class="h_title2">How We Use Personal Information</h2>
        </div>
        <p>KB assures you that:</p>
        <p>We understand your personal information is important and we are committed to protecting your privacy in the online environment.</p>
        <p>We only use your personal information:</p>
        <dl class="explain">
          <dt>For the purpose of processing Financial Transactions additional description</dt>
          <dd>
            KB uses personal information for the purpose of making inquires on personal credit information through credit bureaus or credit information centralization agencies
            pertaining to financial transactions, making a decision on building a financial transaction relationship, establishing/keeping/executing/managing a financial
            transaction relationship, investigating financial incidents, resolving disputes, addressing customer complaints or fulfilling statutory obligations.
          </dd>
          <dd>additional description Financial Transaction defines all relevant banking transaction (including loan, deposit, foreign exchange etc.).</dd>
        </dl>
        <dl class="explain">
          <dt>For the purpose of dealing with Online Transactions</dt>
          <dd>
            KB uses personal information for the purpose of identifying frequency of customer visits to our website, getting statistic concerning service utilization, tracing and
            searching details of electronic financial transactions, or referring to statistics to develop security measures.
          </dd>
        </dl>
        <dl class="explain">
          <dt>For Others</dt>
          <dd>
            - Sign up and Manage a membership
            <br />
            - Help us to provide our products and services
            <br />
            - Improve our service
            <br />
            - Inform you of products you have indicated an interest in
            <br />
            - Provide opportunities for engagement by giving free gifts or running customer promotion
            <br />
            - Career
            <br />
            - Advise you of products or services which KB may offer now or in the future
            <br />
            - Enforce KB’s rights under any agreement or security KB has with you including, without limitation, for debt recovery purposes
            <br />
            - Carrying out any activity in connection with legal, governmental or regulatory requirements or use in connection with legal proceedings, crime or fraud prevention,
            detection or prosecution
            <br />
            - Providing to law enforcement agencies and other government bodies if required by law
            <br />
            - Any other purpose you have consented to KB using the information for
          </dd>
        </dl>
        <br />
        <p>When we need to change purpose of information we obtain, we will ask you to seek the prior consent</p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">Period of Processing andRetention of Personal Information</h2>
        </div>
        <p>
          Personal Information with respect to financial transactions shall be kept and used for the period from the date the information is collected until the date up to 10 years
          following the termination of financial transactions provided that such information shall be used only for investigating financial incidents, resolving disputes,
          addressing customer complaints or fulfilling legal obligations or performing risk management operations of KB after the date of termination of such financial
          transactions.
        </p>
        <br />
        <p>
          Personal information obtained for the purpose of personal informationinquiry shall be kept and used for the period from the day you agree to the collection / utilization
          of personal information to the date 10 years following the date you withdraw such consent provided that such information shall be used only for investigating financial
          incidents, resolving disputes, addressing customer complaints or fulfilling statutory obligations on or after the end date of your consent to providing personal
          information and authorizing inquires to be made thereon.
        </p>
        <br />
        <p>
          Personal Information pertaining to promotion or sale of products and services shall be kept and used for the period from the date of consent to the collection and use of
          such information to the date 10 years following the date you withdraw the consent provided, that such information shall be used only for investigating incidents,
          resolving disputes, addressing customer complaints or fulfilling statutory obligationswith respect to above-stated purposeson or after the day when the consent is
          withdrawn. Also, we may contact you to inform you of services and products available from KB during the retention period. If you do not wish to receive these offers
          please email us or call us on +64-9-366-1000.
        </p>
        <br />
        <p>
          Any personal information that you provide to KB will be held by KB (whether physically or electronically) at Level 19, 135 Albert Street, PO BOX 7506, Wellesley Street,
          Auckland, New Zealand
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">Disclosure of Personal Information</h2>
        </div>
        <p>
          Under the Privacy Act 1993 (New Zealand), you have rights of access to and correction of personal information that KB holds. You have the ability to correct or change the
          information collected at any time and from time to time by making a written request to KB. If KB refuses to disclose the information KB shall provide you with written
          reasons for the refusal within three (3) business days of request for disclosure of the information.
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">Information We Provide with a 3rd party</h2>
        </div>
        <p>
          KB uses your personal information within the scope of purposes determined in tis Privacy Policy and shall not without your prior consent exceed the prescribed scope or
          provide such information to a 3rd party except in the following circumstances where personal information may be used for purposes beyond the original scope or furnished
          to a 3rd party unless such act may unreasonably prejudice interests of you or the third party:<br />
          <br />
        </p>
        <ul class="list txt">
          <li>You have given prior consent to provision or disclosure of personal information to a third party.</li>
          <li>There are regulations or laws permitting or requiring such act.</li>
          <li>
            It is clearly deemed necessary for urgent protection of life, body or property of you or a third party in cases where you or your legal representative is not in a state
            to express yourselves or you are not reachable for prior consent for reasons including but not limited to unknown address.
          </li>
          <li>
            Personal information is provided in a format which makes it impossible to identify individuals in cases where such information is required for statistic or academic
            research purposes.
          </li>
        </ul>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">Outsourcing of Personal Information Processing</h2>
        </div>
        <p>
          If using a third party to process the personal information, KB ensures the third party is bound to abide by laws and regulations governing personal information
          protections and prohibition of personal information provision to a third party and agrees to be bound by the obligations set out in this Privacy Policy.
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">RIGHTS and Obligation, And Ways to Enforce Them</h2>
        </div>
        <p>
          You are entitled to demand access to personal information handled by KB pertaining to you or children aged under 16 (only if you are their duly authorized legal
          guardian). You consent to receiving copies of information electronically.
        </p>
        <p>
          You may demand that KB correct or delete personal information you have read if the information differs from the truth or is not verifiable unless such information is
          regulated by laws or regulations.
        </p>
        <p>
          You may demand that KB suspend processing your personal information provided that KB may reject such demand for suspension of information processing by giving you the
          reason for rejection if:
          <br />
          <br />
        </p>
        <ul class="list txt">
          <li>It is required by law or KB cannot but process your information to fulfill our obligations that are required by laws and regulations.</li>
          <li>Suspension of information processingmay harm life or body of another person or unreasonably prejudice property or other interests of another person.</li>
          <li>
            Our failure to process personal information interferes with our performance of services to you including but not limited to failure to provide contracted services to
            you in cases where you have not explicitly expressed your intention to terminate the contract.
          </li>
        </ul>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">Items of Personal Information Required</h2>
        </div>
        <p>
          KB collects necessary and optional information as follows which is required for establishing·keeping·executing·managing financial transactions and offering products and
          services.
        </p>
        <dl class="explain">
          <dt>Necessary Information</dt>
          <dd>
            - Personal identifier: unique identifiers including name, personal identification number, nationality, contact information such as address, email and phone number, etc
            <br />
            - Information on financial transactions: product type, transaction terms(interest rate, maturity, security, etc), date and time of transaction, transaction amount, etc
            <br />
            - Any other information generated from providing financial services or establishing·keeping·executing and managing financial transactions
          </dd>
        </dl>
        <dl class="explain">
          <dt>Optional Information</dt>
          <dd>
            - Information stated on transaction application forms other than personal identifiers, or any other information given by you
            <br />
            - Housing, family status, length of residence, household members, marital status, etc
          </dd>
        </dl>
        <dl class="explain">
          <dt>Information collected fromInternet Banking</dt>
          <dd>
            - Tracking Internet Banking transactions: your user ID, date and time of log-in, IP address, HDD serial, MAC address, and etc
            <br />
            - Statistical data to organize our Security Policy: personal firewall setting, OS type, security patches, firewall setting, remote access setting, browser version,
            keyboard type, etc
          </dd>
        </dl>
        <dl class="explain">
          <dt>Collection Methods</dt>
          <dd>
            - Directly from customers who visit our branches
            <br />
            - Website, written forms, fax, phone, Q and A message board, email, entry for promotional events, request for delivery
            <br />
            - Collection tool for information populated
            <br />
            - Third party agencies including without limitation credit reporting agencies
          </dd>
        </dl>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">Use of Cookies</h2>
        </div>
        <p>
          KB uses technology in order to offer you the most convenient, secure and relevant services. An example of the technology that KB uses is a “cookie”. A cookie is an
          element of data that the website can send to your browser, which may then store it on your system. KB presently uses cookies to maintain our security requirements during
          your use of our website.When a user is connected with the website, the service provider’s computer can read the contents of the cookie in the user’s browser and provide
          services by finding the user’s additional information in its own computer without additional input of ID etc., concerning the connection.
        </p>
        <br /><br />
        <p>
          It is also important that you know that to transact with KB you do not necessarily need to enable your browser to accept the cookies. You may be able to get your browser
          to notify you when you receive a cookie giving you the chance to decide whether or not to accept it. There is also a lot of information on the Internet in respect of
          cookies.
        </p>
        <p>Please note some information and/or services may not be available if you disable your browser not to accept cookies.</p>
        <p>
          Please also note that while the KB website hyperlinks to various other websites, KB is not responsible for the privacy practice of those websites and/or the reliability
          of the information published on those websites.
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">Destruction of Personal Information</h2>
        </div>
        <p>
          In case the retention period of personal information expires, KB shall destroy personal information in 5 business days when such information becomes of no use for reasons
          such as expiration of retention period, fulfillment of purpose of personal information handling, discontinuation of relevant services or closure of business, etc. unless:
          <br />
          <br />
        </p>
        <ul class="list txt">
          <li>
            Credit information centralization agencies or credit bureaus retain personal credit information(only for the allowed retention period) for the purpose of centralized
            management utilization of credit information or assessment of personal creditworthiness.
          </li>
          <li>
            Credit bureaus, etc. retain personal credit information for the period of effectiveness of civil, criminal obligations or for the period under a statute of limitations
            or hold personal credit information as evidence to resolve disputes.
          </li>
          <li>In case KB is obliged to preserve personal information in accordance with the law.</li>
          <li>There are any other reasonable causes similar.</li>
        </ul>
        <p>
          <br />
          Documents and prints that contain personal information should be disintegrated or destroyed by fire and electronic formed personal information should be eliminated
          permanently so that restoration is impossible.
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">How We Protect Your Privacy</h2>
        </div>
        <p>KB takes technical and administrative measures to keep your personal information safe</p>
        <dl class="explain">
          <dt>Encryption of personal information</dt>
          <dd>
            Your personal information and passwords are accessible only by you because it is stored and managed through encryption. Files and transmission data containing important
            data are protected via separate security measures including encryption or file locking.
          </dd>
        </dl>
        <dl class="explain">
          <dt>Technical Measures against Hacking</dt>
          <dd>
            Our virtual keyboard keeps the value you input safe from leaks To prevent any leakage or destruction of personal information triggered by hacking or computer viruses,
            KB recommends that you install security programs which areupdated and, monitored on a periodic basis while placing a system in an access restricted area and conducting
            technical/physical monitoring and access block from outside.
          </dd>
        </dl>
        <dl class="explain">
          <dt>Restricted Access Personal Data-handling System</dt>
          <dd>
            KB takes measures required for restricting access to personal information by authorizing, modifying or terminating access to database system which processes personal
            information.
          </dd>
        </dl>
        <dl class="explain">
          <dt>Minimize personal information handlers</dt>
          <dd>Handlers of personal information shall be designated and be exclusively provided with minimum personal information.</dd>
        </dl>
        <br />
        <dd>
          To ensure full security you will need to take appropriate steps to ensure that your Internet browser is capable of supporting our website's encryption requirements. More
          information on the Internet browsers we recommend can be found <router-link :to="{ name: 'kbBankingService' }" style="text-decoration: underline">here</router-link>. Our
          website does not collect personal identifying information about you except where specifically requested by you or us.
        </dd>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">Modification of the Privacy Policy</h2>
        </div>
        <p>
          In case of any changes to the Privacy Policy, the timing of amendment and effectuation as well as details of changes shall be disclosed on our website. Comparison of
          before and after changes shall be disclosed to help you better grasp details of the changes.
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">Things You Need to Know for Protection of Personal Information</h2>
        </div>
        <p>
          Please keep in mind that the information you provide online, in bulletin boards, e-mail or messengers can be collected or used by others. You may get messages you do not
          want in such a case.
        </p>
        <p>
          You are responsible for keeping your ID, User Password and OTP (One Time Password) private and confidential, and you should take care when you access Internet Banking.
        </p>
        <p>KB is not responsible for any accident that happens by your negligence or misconduct in taking care of personal information.</p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">Remedy for Infringement of Rights</h2>
        </div>
        <p>Please contact our Customer Service Center or the organizations below for more information or assistance</p>
        <p>
          <strong class="fc_point1">Kookmin Bank Auckland Branch (+64 9 366 1000)</strong>
        </p>
      </div>
      <div class="wrap_cont type2">
        <div class="wrap_title">
          <h2 class="h_title2">Personal Information Protection Manager</h2>
        </div>
        <dl class="addr">
          <strong class="fc_point1">Kookmin Bank Auckland Branch Manager KIM, Dohan</strong>
          <dd>
            <strong class="fc_point1">[Physical Address]</strong>
            <span>Level 16, 88 Shortland Street, Auckland CBD, New Zealand, 1010</span>
          </dd>
          <dd>
            <strong class="fc_point1">[Postal Address]</strong>
            <span>PO Box 7506, Victoria Street West, Auckland CBD, New Zealand, 1142</span>
          </dd>
          <dd>Tel : +64 9 366 1000</dd>
        </dl>
      </div>
      <div class="wrap_cont type2">
        <div>
          <p>KB KOOKMIN BANK Privacy Policy Version: Ver 2.0</p>
          <p>Effective Date for Privacy Policy: 30.06.2020</p>
        </div>
      </div>
      <br /><br /><br />
    </template>
  </article>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  name: "ServiceJoinStep2Contentsogauc",
  computed: {
    ...mapFields(["lang"]),
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
